import { defineMessages } from 'react-intl';

const messages = defineMessages({
  treeTitle: {
    defaultMessage: 'Select Service...',
    id: 'zUkQnC',
    description: 'Title of services tree',
  },
  internationalLabel: {
    defaultMessage: 'International',
    id: 'ToqMar',
    description: 'International label in services tree',
  },
  domesticLabel: {
    defaultMessage: 'Domestic',
    id: 'EYzLKc',
    description: 'Domestic label in services tree',
  },
  requiredDescription: {
    defaultMessage: 'Require that fulfillment providers use these shared services',
    id: 'vK+JVf',
    description: 'Require description at the top of modal body',
  },
  noCarriers: {
    defaultMessage: 'You have no carriers currently connected. Click <link>here</link> to connect more carriers.',
    id: 'QL8Eot',
    description: 'Message with information that no carrier are integrated and link to settings page.',
  },
});
export default messages;
